import { page } from '@/store/modules/page';
import { Tabbar, EntryItem, Bottom, TabbarItemProps, IconDef, Button } from '@ohu-mobile/core';
import { HomeDoorOutlined, UserSmileOutlined, HomeDoorFilled, UserSmileFilled } from '@ohu-mobile/icons';
import { BillOutlined, BillFilled } from '@/icons';
import TSXComponent from '../../utils/tsx-component';
import Component from 'vue-class-component';
import { SettingModule } from '../../store/modules/setting';
import { resetUserLevel } from 'server-api';

const tabs: Array<TabbarItemProps & { activeIcon: IconDef, text: string }> = [
  { to: '/', icon: HomeDoorOutlined, activeIcon: HomeDoorFilled, text: '首页' },
  { to: '/wish/list/view', icon: BillOutlined, activeIcon: BillFilled, text: '志愿单' },
  { to: '/user-center', icon: UserSmileOutlined, activeIcon: UserSmileFilled, text: '个人中心' },
];

@Component({
  name: 'app',
  components: {
    [EntryItem.name]: EntryItem,
  },
})
export default class App extends TSXComponent {
  get hideTab() {
    return this.$route.query.showTab === '0';
  }
  get includes() {
    return page.includes;
  }

  get isTab() {
    return this.$route.meta.isTab;
  }

  get tabVisible() {
    if (this.hideTab) { return false; }
    return !!this.isTab && SettingModule.showTab;
  }

  public renderTabs() {
    const currentPath = this.$route.path;
    return (
      <Tabbar value={currentPath}>
        {
          tabs.map(({ to, icon, activeIcon, text }) => {
            const props: TabbarItemProps = {
              icon: to === currentPath ? activeIcon : icon,
              name: to as string,
              to,
            };
            return (
              <Tabbar.Item {...{ props }}>{text}</Tabbar.Item>
            );
          })
        }
      </Tabbar>
    );
  }

  public render() {
    return (
      <div class={{ 'app': true, 'has-tab': this.isTab }}>
        {
          process.env.NODE_ENV === 'development'
          &&
          <Button style="position:fixed; right: 10px; bottom: 100px; z-index: 9999999;" type="primary" round size="sm" onClick={async () => {
            await resetUserLevel();
          }}>reset</Button>
        }
        <main>
          <keep-alive include={this.includes}>
            <router-view></router-view>
          </keep-alive>
        </main>
        <Bottom class="tabs" tag="footer" visible={this.tabVisible}>
          { this.renderTabs() }
        </Bottom>
      </div>
    );
  }
}
